const returnStatusEnum = Object.freeze({
    PENDING   : 5,
    ACCEPT    : 10,
    REJECTED  : 15,
});
export default returnStatusEnum;
